module.exports = __webpack_public_path__ + "static/media/hall-PD.a2228f60.svg";